import { buildSkillStep, createUploadFileField } from "@/core/skillForms/builder";

export const createBaseAppealSkillStep2 = buildSkillStep({
  title: "Anexo",
  description: "Anexe o arquivo abaixo para fornecer contexto à IA sobre o caso:",
  fields: [
    createUploadFileField({
      name: "reference_piece",
      ui: {
        label: "Anexar decisão/sentença",
      },
    }),
  ],
});
